import { render, staticRenderFns } from "./CalendarV3.vue?vue&type=template&id=188cd340&scoped=true"
import script from "./CalendarV3.vue?vue&type=script&lang=ts"
export * from "./CalendarV3.vue?vue&type=script&lang=ts"
import style0 from "./CalendarV3.vue?vue&type=style&index=0&id=188cd340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cd340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
